import type { TwilioEnvVar } from '@/api/endpoints/platform';

/** The server's Twilio variables, in the order an operator sets them. */
export const TWILIO_ENV_VAR_ORDER: TwilioEnvVar[] = ['TWILIO_ACCOUNT_SID', 'TWILIO_AUTH_TOKEN', 'TWILIO_API_KEY', 'TWILIO_API_SECRET', 'TWILIO_TWIML_APP_SID'];

/** The last 12 months, newest first, as YYYY-MM values with a label in the active locale (QW-h11). */
export function lastMonths(locale: string, now = new Date(), count = 12): Array<{ value: string; label: string }> {
  const fmt = new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' });
  return Array.from({ length: count }, (_, i) => {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const label = fmt.format(d);
    return { value: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`, label: label.charAt(0).toUpperCase() + label.slice(1) };
  });
}
